import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const WorkflowManagementContent = lazy(() => import('./WorkflowManagementContent'));



const WorkflowManagement = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <WorkflowManagementContent />
        </Suspense>
    );
}

export default WorkflowManagement;